import { render } from "./preloader.vue?vue&type=template&id=448db536&scoped=true"
import script from "./preloader.vue?vue&type=script&lang=ts"
export * from "./preloader.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-448db536"

export default script